import { render, staticRenderFns } from "./SimulateStat.vue?vue&type=template&id=3084ac44&scoped=true&"
import script from "./SimulateStat.vue?vue&type=script&lang=js&"
export * from "./SimulateStat.vue?vue&type=script&lang=js&"
import style0 from "./SimulateStat.vue?vue&type=style&index=0&id=3084ac44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3084ac44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VFlex,VLayout})
